import { TenantEntity } from '../TenantEntity'
import { getVesselList, getEDICode, getVesselCarriers } from '@/api/vessel'

export class Vessel extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get vesselId() {
    return this._data.vesselId
  }
  set vesselId(vesselId) {
    this._data.vesselId = vesselId || 0
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }
  get imoCode() {
    return this._data.imoCode
  }
  set imoCode(imoCode) {
    this._data.imoCode = imoCode
  }
  get mmsiCode() {
    return this._data.mmsiCode
  }
  set mmsiCode(mmsiCode) {
    this._data.mmsiCode = mmsiCode
  }
  get callSign() {
    return this._data.callSign
  }
  set callSign(callSign) {
    this._data.callSign = callSign
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get importVoyage() {
    return this._data.importVoyage
  }
  set importVoyage(importVoyage) {
    this._data.importVoyage = importVoyage || false
  }
  get regCountry() {
    return this._data.regCountry
  }
  set regCountry(regCountry) {
    this._data.regCountry = regCountry
  }
  // 获取船名列表
  static async getVesselList() {
    return await getVesselList().then(res => res.data)
  }
  // 获取当前船公司的EDI
  static async getEDICode(vessel, voyageNo, portOfCall, carrierId) {
    return await getEDICode({ vessel, voyageNo, portOfCall, carrierId }).then(res => res.data)
  }
  // 船名对应船公司
  async getVesselCarriers() {
    const data = this._data
    if (typeof data.vesselCarriers !== 'object') {
      data.vesselCarriers = await getVesselCarriers({ vesselUuid: data.uuid }).then(res => res.data)
    }
    return data.vesselCarriers
  }
}
